import { Link } from "react-router-dom";
import FB from "../assets/icons/footer-fb.svg";
import Insta from "../assets/icons/footer-insta.svg";
import Twitter from "../assets/icons/footer-twitter.svg";
import linkdin from "../assets/icons/footer-in.svg";
import mail from "../assets/icons/mail.svg";
import location from "../assets/icons/location.svg";
import phone from "../assets/icons/phone.svg";
import logo from "../assets/images/logo.png";

export default function Footer() {
  const socialLinks = [
    { link: "", icon: FB },
    { link: "", icon: linkdin },
    { link: "", icon: Twitter },
    { link: "", icon: Insta },
  ];

  return (
    <div className="footer_container">
      <div className="footer_topSection">
        {/* Logo + About */}
        <div className="footer_column footer_aboutCol">
          <Link to="/" className="footer_logoWrapper">
            <img src={logo} className="footer_logo" />
          </Link>
          <p className="footer_aboutText">
            VeriMED is a concierge-style geriatric care service connecting
            families abroad with world-class medical teams in Cameroon.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer_column">
          <p className="footer_columnTitle">Quick Links</p>
          <div className="footer_linkGroup">
            <Link to="/" className="footer_link">
              Home
            </Link>
            <Link to="/about" className="footer_link">
              About Us
            </Link>
            <Link to="/services" className="footer_link">
              Services
            </Link>
            <Link to="/familiesCaring" className="footer_link">
              Families Caring
            </Link>
            <Link to="/contactus" className="footer_link">
              Contact Us
            </Link>
          </div>
        </div>

        {/* Services */}
        <div className="footer_column">
          <p className="footer_columnTitle">Services</p>
          <div className="footer_linkGroup">
            <Link to="/services/2" className="footer_link">
              In-Home Medical Visits
            </Link>
            <Link to="/services/3" className="footer_link">
              Virtual Consultations
            </Link>
            <Link to="/services/7" className="footer_link">
              Care Coordination
            </Link>
            <Link to="/services/4" className="footer_link">
              Vitals & Medication Tracking
            </Link>
            <Link to="/services/5" className="footer_link">
              Chronic Disease Support
            </Link>
          </div>
        </div>

        {/* More */}
        <div className="footer_column">
          <p className="footer_columnTitle">More</p>
          <div className="footer_linkGroup">
            <Link to="/faq" className="footer_link">
              FAQ
            </Link>
            <Link to="/termsandconditions" className="footer_link">
              Terms & Conditions
            </Link>
            <Link to="/privacypolicy" className="footer_link">
              Privacy Policy
            </Link>
          </div>
        </div>

        {/* Contact */}
        <div className="footer_column" style={{ marginTop: 20 }}>
          <div className="footer_contactGroup">
            <Link to="/" className="footer_contactLink">
              <img src={location} className="footer_icon" />
              Home Based Primary Care & Home Health Care in Cameroon
            </Link>

            <Link to="mailto:info@verimed.care" className="footer_contactLink">
              <img src={mail} className="footer_icon" />
              info@verimed.care
            </Link>

            <Link to="/" className="footer_contactLink">
              <img src={phone} className="footer_icon" />
              +1 551 502 0063
            </Link>

            <Link to="/" className="footer_contactLink">
              <img src={phone} className="footer_icon" />
              +237 650 419986
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="footer_bottomBar">
        <div className="footer_bottomContent">
          <p className="footer_copyright">
            Copy Right ©2025 verimed. All Rights Reserved.
          </p>

          <div className="footer_socials">
            {socialLinks.map((item, index) => (
              <div className="footer_socialIconWrapper" key={index}>
                <img src={item.icon} className="footer_socialIcon" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
